import React, { useEffect, useState, useId } from "react";
import "./charts.css";

// Speedometer-style semicircle gauge. `pct` is 0..1 (earned / ceiling).
// Arc reveals + needle swings on mount via CSS transitions.
export default function Gauge({ pct = 0, centerTop, centerBottom }) {
  const id = useId().replace(/:/g, "");
  const [shown, setShown] = useState(false);
  useEffect(() => {
    const t = requestAnimationFrame(() => setShown(true));
    return () => cancelAnimationFrame(t);
  }, []);

  const clamped = Math.max(0, Math.min(1, pct || 0));
  const cx = 100, cy = 100, r = 80;
  const full = `M ${cx - r} ${cy} A ${r} ${r} 0 0 1 ${cx + r} ${cy}`;

  // dashoffset reveal: pathLength normalized to 100
  const revealOffset = shown ? 100 - clamped * 100 : 100;
  // needle: -90deg (left) at 0, +90deg (right) at 1
  const needleDeg = shown ? clamped * 180 - 90 : -90;

  return (
    <div className="gauge">
      <svg viewBox="0 0 200 116" width="100%">
        <defs>
          <linearGradient id={`g-${id}`} x1="0" y1="0" x2="1" y2="0">
            <stop offset="0%" stopColor="#2bf5a6" />
            <stop offset="55%" stopColor="#ffcf5c" />
            <stop offset="100%" stopColor="#ff5a7a" />
          </linearGradient>
        </defs>

        {/* track */}
        <path d={full} fill="none" stroke="rgba(255,255,255,0.08)" strokeWidth="16" strokeLinecap="round" />

        {/* value arc */}
        <path
          className="gauge-arc"
          d={full}
          fill="none"
          stroke={`url(#g-${id})`}
          strokeWidth="16"
          strokeLinecap="round"
          pathLength="100"
          strokeDasharray="100"
          strokeDashoffset={revealOffset}
        />

        {/* needle */}
        <g
          className="gauge-needle"
          style={{ transform: `rotate(${needleDeg}deg)`, transformOrigin: `${cx}px ${cy}px` }}
        >
          <line x1={cx} y1={cy} x2={cx} y2={cy - r + 10} stroke="var(--text)" strokeWidth="3" strokeLinecap="round" />
        </g>
        <circle cx={cx} cy={cy} r="7" fill="var(--text)" />
        <circle cx={cx} cy={cy} r="3" fill="var(--bg)" />
      </svg>

      <div className="gauge-label">
        {centerTop && <div className="gauge-top">{centerTop}</div>}
        {centerBottom && <div className="gauge-bottom">{centerBottom}</div>}
      </div>
    </div>
  );
}
